import { useDispatch, useSelector } from "react-redux";
import { apiGetFinancials } from "api/financialApi";
import { setQueryParam } from "helpers/queryParam";
import { apiGetWarehouses } from "../../api/warehouseApi";
import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicDateInput from "../BasicInputs/BasicDateInput";
import { indexData } from "forms";
import useDateState from "helpers/useDateState";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function TableSelect({
    entity,
    refetch,
    activeTab,
    type,
    onChange,
}: {
    entity: "bank" | "fund" | "cashier" | "warehouse";
    refetch: (p: any) => void;
    activeTab?: any;
    type: string;
    onChange?: (val: any, option?: any, dates?: any) => void;
}) {
    const queryParam = `${entity}Id`;
    const dispatch: any = useDispatch();
    const { token } = useSelector((state: any) => state).businessReducer.business;
    const [searchParams] = useSearchParams();
    const financialsState = useSelector((state: any) => state).financialReducer;
    const warehousesState = useSelector((state: any) => state).warehouseReducer;
    const paginationState = useSelector((state: any) => state.paginationReducer);
    const tabs = indexData(type);
    const { setDates, fromDate, toDate } = useDateState();
    const [value, setValue] = useState(searchParams.get(queryParam) || null);
    const options =
        entity === "warehouse"
            ? warehousesState
                ? warehousesState.warehouses
                : []
            : financialsState
                ? financialsState[`${entity}s`]
                : [];

    useEffect(() => getOptions(), [token]);

    useEffect(() => handleChange(), [paginationState, toDate, fromDate]);

    useEffect(() => {
        if (onChange && value) {
            onChange(
                value,
                options.find((x: any) => x.value === parseInt(value)),
                { fromDate, toDate }
            );
        }
    }, [value]);

    function getOptions() {
        if (entity === "warehouse") {
            dispatch(apiGetWarehouses(token));
        } else {
            dispatch(apiGetFinancials(entity, token));
        }
    }

    const handleChange = (val?: any) => {
        onChange && onChange(
            value,
            // @ts-ignore
            val ?? options.find((x: any) => x.value === parseInt(value)),
            { fromDate, toDate }
        );

        let { search, sort } = paginationState;
        let opts: any = {};
        if (fromDate && toDate) {
            opts = { subColumn: "date", searchText: fromDate, searchTextAlt: toDate };
        }

        if (val) {
            setValue(val);
            setQueryParam(queryParam, val);

            return dispatch(
                refetch({ pagination: paginationState, token, options: opts, type: entity, search, sort, id: val, tab: activeTab })
            );
        } else if (value) {
            setQueryParam(queryParam, value);

            return dispatch(
                refetch({ pagination: paginationState, token, options: opts, type: entity, search, sort, id: value, tab: activeTab })
            );
        }
    };
    const placeholders = {
        bank: "بانک",
        fund: "تنخواه",
        cashier: "صندوق",
        warehouse: "انبار",
    };

    return (
        <div className="flex items-center mt-6 justify-start gap-5 flex-wrap">
            <div style={{ width: 245 }}>
                <BasicDateInput
                    range
                    placeholder="کل سال مالی"
                    onChange={(x) => setDates(x)}
                    defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}
                />
            </div>
            <BasicSelect
                style={{ minWidth: 245 }}
                defaultValue={value}
                options={options}
                onChange={handleChange}
                placeholder={placeholders[entity]}
                withSearch
                withRefresh
                refreshList={getOptions}
            />
        </div>
    );
}
